export default __webpack_public_path__ + "static/media/power-outlet.b8e56fdc.svg";